import { JSONSerializer } from './JSONSerializer'

/**
 * @param {string} key
 * @param {string | null} [defaultValue = null]
 * @param {Storage} [storage = localStorage]
 *
 * @returns {string | null}
 */
export function getStorageItem(
  key,
  defaultValue = null,
  storage = localStorage
) {
  return storage.getItem(key) ?? defaultValue
}

/**
 * @param {string} key
 * @param {string | null} value
 * @param {Storage} [storage = localStorage]
 */
export function setStorageItem(key, value, storage = localStorage) {
  if (value == null) {
    storage.removeItem(key)
  } else {
    storage.setItem(key, value)
  }
}

/**
 * @param {string} key
 * @param {Storage} [storage = localStorage]
 */
export function removeStorageItem(key, storage = localStorage) {
  setStorageItem(key, null, storage)
}

/**
 * @template {*} TValue
 *
 * @param {string} key
 * @param {TValue | null} [defaultValue = null]
 * @param {Storage} [storage = localStorage]
 *
 * @returns {TValue | null}
 */
export function getStorageSerializedItem(
  key,
  defaultValue = null,
  storage = localStorage
) {
  const itemValue = getStorageItem(key, null, storage)

  let value = null

  try {
    value = JSONSerializer.deserialize(itemValue)
  } catch (error) {
    console.warn(`Cannot parse storage item "${key}": "${itemValue}"`, error)
  }

  return value ?? defaultValue
}

/**
 * @param {string} key
 * @param {* | null} value
 * @param {Storage} [storage = localStorage]
 *
 * @returns {*}
 */
export function setStorageSerializedItem(key, value, storage = localStorage) {
  try {
    setStorageItem(key, JSONSerializer.serialize(value), storage)
  } catch (error) {
    console.warn(`Cannot stringify storage value ${key}`, error)
  }
}
